import { motion } from "framer-motion";
import { RETAIL_SHOPS, OFFICES } from "@/lib/constants";

const TableBlock = ({ title, rows, label, testId }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
    className="bg-[#0A0A0B] border border-white/10 overflow-hidden"
    data-testid={testId}
  >
    <div className="flex items-center justify-between px-6 md:px-8 py-5 border-b border-white/10">
      <h3 className="font-serif text-2xl md:text-3xl text-[#F8F6F0] tracking-tight">{title}</h3>
      <span className="text-[15px] uppercase tracking-[0.3em] text-[#D4AF37]">
        {rows.length} {rows.length === 1 ? "Config" : "Configurations"}
      </span>
    </div>
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-white/10">
            <th className="text-left px-6 md:px-8 py-4 text-[12px] uppercase tracking-[0.3em] text-[#D4AF37] font-medium">
              {label}
            </th>
            <th className="text-left px-6 md:px-8 py-4 text-[12px] uppercase tracking-[0.3em] text-[#D4AF37] font-medium">
              Carpet Area
            </th>
            <th className="text-left px-6 md:px-8 py-4 text-[12px] uppercase tracking-[0.3em] text-[#D4AF37] font-medium">
              Salable Area
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, idx) => (
            <tr
              key={idx}
              className="border-b border-white/5 hover:bg-[#D4AF37]/[0.04] transition-colors duration-300 group"
            >

              <td className="px-6 md:px-5 py-5 text-sm md:text-base text-[#F8F6F0] font-light">
              <span className="inline-flex items-center gap-2">
                <span className="text-[#D4AF37] w-4 text-center group-hover:opacity-100 opacity-0 transition-opacity">›</span>
                <span>{r.no}</span>
              </span>
              </td>
              <td className="px-6 md:px-8 py-5 text-sm md:text-base text-[#F8F6F0] font-light">
                {r.carpet} <span className="text-[#A0A0A0] text-xs ml-1">SQFT</span>
              </td>
              <td className="px-6 md:px-8 py-5 text-sm md:text-base text-[#F8F6F0] font-light">
                {r.salable} <span className="text-[#A0A0A0] text-xs ml-1">SQFT</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </motion.div>
);

export const Units = () => {
  return (
    <section id="units" className="relative py-24 md:py-32 border-t border-white/5" data-testid="units-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-16 md:mb-20 max-w-3xl"
        >
          <div className="text-xs uppercase tracking-[0.4em] text-[#D4AF37] mb-5">Unit Configuration</div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#F8F6F0] leading-[1.05] tracking-tight">
            Spaces measured for{" "}
            {/* <span className="italic gold-text"> ambition.</span> */}
            <span className="italic bg-gradient-to-r from-[#ffb413] via-[#D4AF37] to-[#ff9900] text-transparent bg-clip-text">
              Growth.
            </span>
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-8">
          <TableBlock title="Retail Shops" rows={RETAIL_SHOPS} label="Shop No." testId="retail-shops-table" />
          <TableBlock title="Offices" rows={OFFICES} label="Office No." testId="offices-table" />
        </div>
      </div>
    </section>
  );
};
